require("malihu-custom-scrollbar-plugin");
require("jquery-mousewheel");

export default () => {
  $(".scroll").mCustomScrollbar();

};


// WEBPACK FOOTER //
// app/scripts/components/scroll.js